import React from 'react'
import styled from 'styled-components'

import DatePicker from 'react-datepicker'
import moment from 'moment'

const SpanPicker = ({
    start, 
    end,
    onChange, 
    format = 'MM/dd/yyyy', 
    label, 
    labelStart, 
    labelEnd
}:
{
    start: Date, 
    end: Date, 
    onChange: Function, 
    format?: string, 
    label?: string, 
    labelStart?: string, 
    labelEnd?: string
}) => {
    
    const startDate = start ? moment(new Date(start), format) : null
    const endDate = end ? moment(new Date(end), format) : null
    
    return <Container>
        {label &&
            <span>{label}</span>
        }
        <div>
            <div>
                {labelStart &&
                    <span>{labelStart}</span>
                }
                <DatePicker
                    selected={startDate}
                    placeholderText="Select a start date..."
                    onChange={date => onChange(date,'start')}
                    startDate={startDate}
                    endDate={endDate} 
                    popperPlacement="bottom-start"
                    selectsStart
                />
            </div>                       
            <div>
                {labelEnd &&
                    <span>{labelEnd}</span>
                }
                <DatePicker
                    selected={endDate}
                    placeholderText="Select an end date..."
                    onChange={date => onChange(date,'end')}
                    startDate={startDate}
                    endDate={endDate}
                    minDate={startDate}
                    popperPlacement="bottom-end"
                    selectsEnd
                />
            </div>
        </div>
        
    </Container>
}

export default SpanPicker

const Container = styled.div`
    margin: 8px 0px;
    .react-datepicker__triangle{
        visibility: hidden;
    }
    >div{
        display: flex;
        flex-direction: row;

        justify-content:  space-between;

        >div{
            display: flex;
            flex-direction: column;

            justify-content: center;
            align-items: left;

            width: calc(50% - 5px);
            margin-bottom: 5px;

            >span{
                display: flex;
                width: 50px;
                margin: auto;
                margin-right: 5px;
                vertical-align: center;
                text-align: center;

                font-style: normal;
                font-size: 11px;
                line-height: 10px;
                
            }
        }
    }
`